import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicyPage.css";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = "Privacy Policy - Orindra";
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        {/* Header */}
        <header className="legal-header">
          <div className="legal-header-content">
            <Link to="/" className="legal-logo">
              <img src="/orindra-logo.png" alt="Orindra logo" />
            </Link>
            <nav className="legal-nav">
              <Link to="/" className="legal-nav-link">
                Back to Home
              </Link>
            </nav>
          </div>
        </header>

        {/* Main Content */}
        <main className="legal-main">
          <div className="legal-content">
            <h1 className="legal-title">PRIVACY POLICY</h1>

            <div className="legal-meta">
              <p>
                <strong>Elvis Tapfumanei (PTY) Ltd</strong>
              </p>
              <p>
                <strong>Registration Number:</strong> 2024/123610/07
              </p>
              <p>
                <strong>Address:</strong> Cape Town, South Africa
              </p>
              <p>
                <strong>Effective Date:</strong> 1st January 2025
              </p>
              <p>
                <strong>Last Updated:</strong> 1st January 2025
              </p>
            </div>

            <hr className="legal-divider" />

            <section className="legal-section">
              <h2>1. INTRODUCTION</h2>
              <p>
                Elvis Tapfumanei (PTY) Ltd ("<strong>Company</strong>", "
                <strong>we</strong>", "<strong>us</strong>", or "
                <strong>our</strong>") operates the Orindra platform ("
                <strong>Service</strong>", "<strong>Platform</strong>", or "
                <strong>Application</strong>"), an intelligent meeting notes
                application that captures, processes, and analyzes conversations
                in real-time using artificial intelligence.
              </p>
              <p>
                This Privacy Policy ("<strong>Policy</strong>") governs the
                collection, use, processing, storage, and disclosure of personal
                information when you use our Service. This Policy complies with
                the Protection of Personal Information Act, 2013 (Act No. 4 of
                2013) ("<strong>POPIA</strong>") of South Africa and the General
                Data Protection Regulation ("<strong>GDPR</strong>") of the
                European Union.
              </p>
              <p>
                By accessing or using our Service, you acknowledge that you have
                read, understood, and agree to be bound by this Privacy Policy.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. DEFINITIONS</h2>
              <p>For the purposes of this Policy:</p>
              <ul>
                <li>
                  <strong>"Personal Information"</strong> means information
                  relating to an identifiable, living, natural person, and where
                  applicable, an identifiable, existing juristic person, as
                  defined under POPIA.
                </li>
                <li>
                  <strong>"Processing"</strong> means any operation or activity
                  concerning personal information, including collection,
                  receipt, recording, organisation, collation, storage,
                  updating, modification, retrieval, alteration, consultation,
                  use, dissemination, merging, linking, restriction,
                  degradation, erasure, or destruction.
                </li>
                <li>
                  <strong>"Data Subject"</strong> means the person to whom
                  personal information relates.
                </li>
                <li>
                  <strong>"Third Party"</strong> means any person other than the
                  data subject, the Company, or a person acting under the direct
                  authority of the Company.
                </li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>3. DATA CONTROLLER INFORMATION</h2>
              <div className="legal-subsection">
                <h3>Data Controller:</h3>
                <p>Elvis Tapfumanei (PTY) Ltd</p>
                <p>Registration Number: 2024/123610/07</p>
                <p>Address: Cape Town, South Africa</p>
                <p>Email: legal@orindra.com</p>
              </div>
              <div className="legal-subsection">
                <h3>Information Officer (POPIA Compliance):</h3>
                <p>Elvis Tapfumanei</p>
                <p>Email: legal@orindra.com</p>
              </div>
              <div className="legal-subsection">
                <h3>Data Protection Officer (GDPR Compliance):</h3>
                <p>Elvis Tapfumanei</p>
                <p>Email: legal@orindra.com</p>
              </div>
            </section>

            <section className="legal-section">
              <h2>4. PERSONAL INFORMATION WE COLLECT</h2>

              <h3>4.1 Information You Provide Directly</h3>
              <div className="legal-subsection">
                <h4>Account Information:</h4>
                <ul>
                  <li>Full name</li>
                  <li>Email address</li>
                  <li>Password (encrypted)</li>
                  <li>Profile picture</li>
                  <li>Organization details</li>
                  <li>Job title and role</li>
                  <li>Phone number (optional)</li>
                  <li>Subscription preferences</li>
                </ul>
              </div>

              <div className="legal-subsection">
                <h4>Meeting Data:</h4>
                <ul>
                  <li>Meeting titles and descriptions</li>
                  <li>Meeting participants and invitees</li>
                  <li>Meeting schedules and calendar information</li>
                  <li>Audio recordings of meetings</li>
                  <li>Meeting transcripts</li>
                  <li>Meeting notes and annotations</li>
                  <li>Action items and decisions</li>
                  <li>Meeting templates and preferences</li>
                </ul>
              </div>

              <div className="legal-subsection">
                <h4>Communication Data:</h4>
                <ul>
                  <li>Messages sent through the platform</li>
                  <li>Feedback and support requests</li>
                  <li>Survey responses</li>
                </ul>
              </div>
            </section>

            <div className="legal-footer">
              <p>
                <strong>Document Version:</strong> 1.0
              </p>
              <p>
                <strong>Effective Date:</strong> 2025-01-01
              </p>
              <p>
                <strong>Last Updated:</strong> 2025-01-01
              </p>
              <p>
                <strong>Next Review Date:</strong> 2026-01-01
              </p>
            </div>

            <div className="legal-disclaimer">
              <p>
                <em>
                  This Privacy Policy has been prepared to comply with the
                  Protection of Personal Information Act (POPIA) of South Africa
                  and the General Data Protection Regulation (GDPR) of the
                  European Union. For legal advice regarding your specific
                  situation, please consult with qualified legal counsel.
                </em>
              </p>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="legal-footer-section">
          <div className="legal-footer-content">
            <div>
              © {new Date().getFullYear()} Orindra. Built for teams who refuse
              to waste time.
            </div>
            <div className="legal-footer-links">
              <Link to="/privacy" className="legal-footer-link">
                Privacy
              </Link>
              <Link to="/terms" className="legal-footer-link">
                Terms
              </Link>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
